import { FC } from 'react';

import { DataPlatform, WarehouseEntityType } from '@/__generated__/graphql';
import { TableDetails } from '../../../catalog/details/components/Panels/TableDetails';
import { ViewDetails } from '../../../catalog/details/components/Panels/ViewDetails';

type GeneralAssetTableProps = {
  assetId: string;
  platform: DataPlatform | null;
  entityType: string;
};

export const GeneralAssetTable: FC<GeneralAssetTableProps> = ({
  assetId,
  entityType,
}) => {
  switch (entityType) {
    case WarehouseEntityType.Table:
      return <TableDetails assetId={assetId} />;
    case WarehouseEntityType.View:
      return <ViewDetails assetId={assetId} />;
    default:
      return <div>Null</div>;
  }
};
